"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { CryptoPaymentMethodType } from "./CryptoPaymentMethod.js";
export function PaymentMethodSwitch({ currentMethod, onMethodChange }) {
    if (!onMethodChange)
        return null;
    const isTransferCrypto = currentMethod === CryptoPaymentMethodType.TRANSFER_CRYPTO;
    const isConnectWallet = currentMethod === CryptoPaymentMethodType.CONNECT_WALLET || currentMethod === CryptoPaymentMethodType.GLOBAL_WALLET;
    // Only show switch if we're in one of the payment states
    if (!isTransferCrypto && !isConnectWallet)
        return null;
    const handleSwitch = () => {
        if (isTransferCrypto) {
            onMethodChange(CryptoPaymentMethodType.CONNECT_WALLET);
        }
        else {
            onMethodChange(CryptoPaymentMethodType.TRANSFER_CRYPTO);
        }
    };
    return (_jsx("div", { className: "order-details-payment-switch-container flex items-center justify-center", children: _jsx("button", { onClick: handleSwitch, className: "order-details-payment-switch-btn text-as-primary/60 hover:text-as-primary text-sm underline transition-colors", children: isTransferCrypto ? "Switch to Connect Wallet" : "Switch to scan / manually send crypto" }) }));
}
